import ReactModal from 'react-modal';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import './Modal.sass';

type ModalProps = {
  ctaButtonText: string;
  description: string;
  header: string;
  hideModal: () => void;
};

ReactModal.setAppElement('#gallery_root');

export const Modal = ({hideModal, header, description, ctaButtonText}: ModalProps) => (
  <ReactModal isOpen className="gallery-modal" overlayClassName="gallery-modal--overlay">
    <div className="gallery-modal--header">
      <div className="gallery-modal--header-container">
        <AlertLineIcon ratio={0.75} color="red" />
        <Typography variant="header5" classNames="gallery-modal--header--text">
          Error: {header}
        </Typography>
      </div>
      <Button
        variant="transparent"
        icon={<CloseLineIcon ratio={0.75} color="black" />}
        onClick={hideModal}
      />
    </div>
    <Typography variant="paragraph2" classNames="gallery-modal--description">
      {description}
    </Typography>
    <Button className="gallery-modal--cta" onClick={hideModal}>
      {ctaButtonText}
    </Button>
  </ReactModal>
);
